import React from 'react';
import { DefaultEventComponent } from './Default';

export default class ReceiveSpecialGuestEvent extends DefaultEventComponent {

    render() {
        let packageData = this.props.receivedMessage.package.data;
        let messageText = packageData.message_text;
        return <>
            <h4>{messageText}</h4>
        </>;
    }

}
